var profileDropdownToggled = false;
var adminDropdownToggled = false;

document.addEventListener('turbolinks:before-visit', () => {
  // on before visit we need to remove from memory the bc, otherwise we will have multiple instances of it
  bc.onmessage = null;
  bc = null;
});
document.addEventListener('turbolinks:load', () => {
  setTimeout(function () {
  setupDropdowns();
  setupBroadcastChannel();
  setupRoleLink();
  setupGoogleAnalytics();
  }, 100); // this is a hack to make sure the turbolinks:load event is fired after the page is loaded
});

 function toggleMenuDropdown(id, bool) {
    var element = document.querySelector(id);
    if (!element) return;
    if (bool) {
      element.classList.remove('hidden');
      setTimeout(function () {
        element.classList.add('ease-in', 'duration-75', 'opacity-100', 'scale-100');
        element.classList.remove('ease-out', 'duration-100', 'opacity-0', 'scale-95');
      }, 100);
    } else {
      element.classList.add('ease-out', 'duration-100', 'opacity-0', 'scale-95');
      element.classList.remove('ease-in', 'duration-75', 'opacity-100', 'scale-100');
      setTimeout(function () {
        element.classList.add('hidden');
      }, 100);
    }
  }

function setupDropdowns(){
  document.addEventListener('click', function () {
    profileDropdownToggled = false;
    adminDropdownToggled = false;
    toggleMenuDropdown('#profileDropdownMenu', profileDropdownToggled);
    toggleMenuDropdown('#adminDropdownMenu', adminDropdownToggled);
  });

  const profileDropdown = document.querySelector('#profileDropdown')
  if (profileDropdown) {
    profileDropdown.addEventListener('click', function (e) {
    e.stopPropagation();
    profileDropdownToggled = !profileDropdownToggled;
    if (profileDropdownToggled && adminDropdownToggled == profileDropdownToggled) {
      adminDropdownToggled = false;
      toggleMenuDropdown('#adminDropdownMenu', adminDropdownToggled);
    }
    toggleMenuDropdown('#profileDropdownMenu', profileDropdownToggled);
    });
  }

  const adminDropdown = document.querySelector('#adminDropdown')
  if (adminDropdown){
    adminDropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      adminDropdownToggled = !adminDropdownToggled;
      if (adminDropdownToggled && adminDropdownToggled == profileDropdownToggled) {
      profileDropdownToggled = false;
      toggleMenuDropdown('#profileDropdownMenu', profileDropdownToggled);
    }
    toggleMenuDropdown('#adminDropdownMenu', adminDropdownToggled);
  });
  }
}

let bc;

function setupBroadcastChannel(){
  // Connection to a broadcast channel
  if (typeof BroadcastChannel !== 'function') {
    console.warn('BroadcastChannel not supported');
  }
  bc = new BroadcastChannel('mictap__broadcast_channel');
  let subscribers = 1;
  let tabId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

  // Example of sending of a very simple message
  bc.postMessage({ type: 'ping', sender: tabId });

  bc.onmessage = function (ev) {
    if (ev.data.tabId === tabId) return;
    switch (ev.data.type) {
      case "ping":
        bc.postMessage({ type: 'pong', sender: tabId });
        // modify UI to show that two tabs are open
        document.getElementById('twoTabsOpenWarning').classList.remove('hidden');
        subscribers++;
        break;
      case "pong":
        subscribers++;
        document.getElementById('twoTabsOpenWarning').classList.remove('hidden');
        break
      case "bye":
        subscribers--;
        if (subscribers <= 1) {
          document.getElementById('twoTabsOpenWarning').classList.add('hidden');
        }
        break
    }
  }

  addEventListener('beforeunload', (evt) => {
    bc.postMessage({type: 'bye', sender: tabId});
  });
}


function setupRoleLink() {

  // TODO: check if user has already joined before, and if the "session" description is set, if it is, just prompt continue

  let rememberMeEl = document.querySelector("#remember-me-input")
  if (rememberMeEl) {
    const MT_remember_me = "mt_remember_me"
    if (localStorage.getItem(MT_remember_me)) {
      rememberMeEl.checked = true
      setRememberUserInfo()
    }
    rememberMeEl.addEventListener("change", function (e) {
      if (e.target.checked) {
        localStorage.setItem(MT_remember_me, true)
        setRememberUserInfo()
      } else {
        localStorage.removeItem(MT_remember_me)
      }
    })
  }

  function setRememberUserInfo() {
    let nameEl = document.querySelector("input[name='name']")
    let emailEl = document.querySelector("input[name='email']")
    const MT_email = "mt_email"
    const MT_name = "mt_name"
    if (nameEl && emailEl) {
      const storedName = localStorage.getItem(MT_name)
      const storedEmail = localStorage.getItem(MT_email)

      if (storedName && storedEmail){
        nameEl.value = storedName
        emailEl.value = storedEmail
      } else {
        localStorage.setItem(MT_name, nameEl.value)
        localStorage.setItem(MT_email, emailEl.value)
      }
    }
    // set listeners on change for inputs and save to local storage
    nameEl.addEventListener("change", function (e) {
      localStorage.setItem(MT_name, e.target.value)
    })
    emailEl.addEventListener("change", function (e) {
      localStorage.setItem(MT_name, e.target.value)
    })

  }
}

function setupGoogleAnalytics() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-FFCCQ8GHPL');
}